import type { ReportingTag } from '@/core/reporting/types'

export enum DiagnosticId {
  AppVersion = 'app-version',
  BuildMode = 'build-mode',
  ServiceWorker = 'service-worker',
  OffscreenCanvasWorker = 'offscreen-canvas-worker',
  CanvasMaxArea = 'canvas-max-area',
  DeviceMemory = 'device-memory',
  HardwareConcurrency = 'hardware-concurrency',
  ShareFiles = 'share-files',
  ShareTarget = 'share-target',
  NativeHeic = 'native-heic',
  NativeAvif = 'native-avif',
  CanvasFilter = 'canvas-filter',
  StorageEstimate = 'storage-estimate',
  StoragePersisted = 'storage-persisted',
  RecentsCount = 'recents-count',
  DevicePixelRatio = 'device-pixel-ratio',
  Viewport = 'viewport',
  ColorGamutP3 = 'color-gamut-p3',
  ColorScheme = 'color-scheme',
  SentryEnabled = 'sentry-enabled',
  SentryLastEventId = 'sentry-last-event-id',
}

export interface DiagnosticRow {
  id: DiagnosticId
  name: string
  value: string
  ok: boolean
  tag: ReportingTag
}
